import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  FullStressTypePDFDownloadResponse,
  ActionType,
  IFullStressTypeDownloadPdfData,
} from "models/stressCheck/fullStressTypeDownloadPdf";
import { httpStatus } from "configs/httpStatus";
import { downloadFullStressPdfRequest } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressDownloadPdfActions";

function* fullStressPdfDownloadSaga({
  payload,
}: {
  payload: IFullStressTypeDownloadPdfData;
}) {
  try {
    const response: FullStressTypePDFDownloadResponse = yield call(
      downloadFullStressPdfRequest,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadFullStressPDFWatcher() {
  yield takeLatest(
    ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF as any,
    fullStressPdfDownloadSaga
  );
}

export default [fork(onDownloadFullStressPDFWatcher)];
